module.exports = __webpack_public_path__ + "static/media/cars.f471a944.svg";